export default "__VITE_ASSET__Dlj_iNfH__"